import * as React from 'react';
import './eventArchivePage.module.scss';
import { observer } from 'mobx-react';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { Page } from '../../components/atoms/layout/Page';
import { PageHeader } from '../../components/atoms/layout/PageHeader';
import { PageBody } from '../../components/atoms/layout/PageBody';
import { observable } from 'mobx';
import { EventListState } from '../../components/organisms/events/states/EventListState';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { EventListPane } from '../../components/organisms/home/EventListPane';
import { OverlayPage } from '../../../commonv3/components/molecules/layout/OverlayPage';
import { V3Routes } from '../../routes';
import { Route, Switch } from 'react-router';
import EventDetailsPane from '../../components/organisms/events/EventDetailsPane';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';

type Props = {
    match: {
        url: string;
    };
};

@withNavigation(NavigationSpecs.home('white', false))
@observer
export class EventArchivePage extends React.Component<Props> {
    @observable eventList = new EventListState();

    componentDidMount(): void {
        this.eventList.init();
    }

    render() {
        const { url } = this.props.match;
        return (
            <Page styleName="page">
                <PageHeader title="EVENT ARCHIVES" subTitle="過去のイベント" showOnMobile={true} />
                <PageBody styleName="body">
                    {this.eventList.eventArchives.loading && <LoaderRow />}
                    <EventListPane
                        events={this.eventList.eventArchives.getOrElse([])}
                        onItemClick={(ev) => GlobalStatesV3.routing.push(V3Routes.eventArchive(ev.id))}
                    />
                    <OverlayPage
                        open={GlobalStatesV3.routing.location.pathname.match(/\/\d+/g) != null}
                        onRequestClose={() => GlobalStatesV3.routing.push(V3Routes.eventArchives())}
                    >
                        <Switch>
                            <Route exact path={`${url}/:eventId`} component={EventDetailsPane} />
                        </Switch>
                    </OverlayPage>
                </PageBody>
            </Page>
        );
    }
}
